module.exports = __webpack_public_path__ + "fdd1733d718ae25033bf87960d8d4288.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Game/cloud.png
 ** module id = 336
 ** module chunks = 0
 **/